var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertIconSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Alert_Icon"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 5",
    width: 24,
    height: 24,
    rx: 6,
    fill: "#48CA93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.5 12.5L10.5 14.5L15.5 9.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertIconSuccess);
export default __webpack_public_path__ + "static/media/Alert_Icon_Success.6a7b5c88a17a3207731b34d9f9ed0263.svg";
export { ForwardRef as ReactComponent };